<template>
 <div class="home text-xs-center" :class="{'py': $vuetify.breakpoint.smAndDown,
                                           'pa': $vuetify.breakpoint.mdAndUp}">

  <h1 :class="{'headline': $vuetify.breakpoint.mdAndDown}" 
       class="grey--text text--darken-2 my-3">Tutti i nostri Servizi</h1>
  <!-- <v-container v-if="userVerified"> -->
  <v-container>
    <v-expansion-panel v-model="panel">
      <v-expansion-panel-content v-for="servizio in servizi" :key="servizio.id">
        <template v-slot:header @click="trattamentoSelezionato(servizio.nome, servizio.prezzo, servizio.durata, servizio.effetto, servizio.luxury)">
          <!-- NOME SERVIZIO -->
          <div :class="{'myStyle1': $vuetify.breakpoint.mdAndDown, 'myStyle3': $vuetify.breakpoint.smAndDown}"  
            class="headline lash-text" @click ="trattamentoSelezionato(servizio.nome, servizio.prezzo, servizio.durata, servizio.effetto, servizio.luxury)">
              {{servizio.nome}} <span v-show="servizio.effetto != 'Laminazione' &&
                                              servizio.effetto != ''"> Effetto </span> {{servizio.effetto}} {{servizio.nota}}
            <span v-if="servizio.luxury==true"> versione LUXURY </span>    
            <span v-else-if="servizio.luxury == false && servizio.effetto != ''"> versione BASE </span> 
            <span class="grey--text text--darken-2  mr-4" style="float:right">€ {{servizio.prezzo}}</span>
          </div>               
        </template>
        
        <v-container>
          <v-layout row wrap>

            <!-- DESCRIZIONE SERVIZIO -->
            <v-flex xs12 md10>
              <span :class="{'myStyle2 subtitle-1': $vuetify.breakpoint.mdAndDown, 
                             'myStyle4': $vuetify.breakpoint.smAndDown,
                             'title': $vuetify.breakpoint.lgAndUp}" 
                             class="font-weight-regular grey--text text--darken-2">{{servizio.descrizione}}
              </span>
            </v-flex>

            <!-- SELEZIONA LASHMAKER -->
            <v-flex xs12 sm5 md3>
                <v-combobox @change="calendarioLashmaker(nomecognome)" class="mt-3" 
                  :items="nomeLashmaker" v-model="nomecognome" 
                  label="Seleziona Lashmaker" 
                  chips 
                  spellcheck="false">
                </v-combobox>
            </v-flex>

            <!-- SELEZIONA IL GIORNO PRENOTAZIONE -->
            <v-flex xs12 sm6 md6>
              <v-menu class="mr-5" >
                <v-text-field class="mt-4" 
                              :class="{'ml-5': $vuetify.breakpoint.mdAndUp, 
                                       'ml-3': $vuetify.breakpoint.smOnly,
                                       'ml-0': $vuetify.breakpoint.xsOnly}" 
                              v-model="formattedDate" slot="activator" 
                              @click="prenota()" readonly  
                              label="Prenota il" 
                              prepend-icon="date_range">
                </v-text-field>
                <v-date-picker
                  v-model="picker"  
                  :allowed-dates="allowedDates"
                  class="my-4"   
                  :min="minDate" 
                  :full-width="lrgData"
                  @change="giornoSelezionato()" 
                  locale="it"     
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 md3></v-flex>

            <v-flex xs12>           
              <div class="mb-2">  <!--v-if="prenotaMattino" -->
                <h4 class="text-xs-center title my-3" :class="{'myStyle2': $vuetify.breakpoint.smAndDown}">
                  {{ layoutMattino }}
                </h4>                
                <span v-for="(orarioDisponibile, index) in orariDisponibili" 
                      :key="orarioDisponibile.index">
                  <v-btn v-if="orarioDisponibile.time < limiteMattino && limiteMattino != ''" 
                         :class="[{ 'lash-btn' : orarioDisponibile.selected, 'ma-1': $vuetify.breakpoint.smAndDown}]"
                         @click="orarioSelezionato(orarioDisponibile.time, index)">
                    {{orarioDisponibile.time}}
                  </v-btn>
                </span>
              </div>            
            </v-flex>

            <!-- <v-flex xs12 lg6 :class="{'mt-3': $vuetify.breakpoint.mdAndDown, 
            'pl-3 orari': $vuetify.breakpoint.lgAndUp}"> -->
            <v-flex xs12>
              <div class="mb-2"> <!--v-if="prenotaPomeriggio"-->
                <h4 class="text-xs-center title my-3" :class="{'myStyle2': $vuetify.breakpoint.smAndDown}">
                  {{ layoutPomeriggio }}
                </h4>
                <span v-for="(orarioDisponibile, index) in orariDisponibili" 
                      :key="orarioDisponibile.index">
                  <v-btn v-if="orarioDisponibile.time >= limitePomeriggio && limitePomeriggio != ''" 
                         :class="[{ 'lash-btn' : orarioDisponibile.selected,  'ma-1': $vuetify.breakpoint.smAndDown }]" 
                         @click="orarioSelezionato(orarioDisponibile.time, index)">
                    {{orarioDisponibile.time}}
                  </v-btn>
                </span> 
              </div>            
            </v-flex>

            <v-flex v-show="!prenotaAttivo" xs12 md3>
              <v-text-field v-model="nomeCliente" class="pa-3" placeholder="Nome"></v-text-field>
            </v-flex>

            <v-flex v-show="!prenotaAttivo" xs12 md3>
              <v-text-field v-model="cognomeCliente" class="pa-3" placeholder="Cognome"></v-text-field>
            </v-flex>

            <v-flex v-show="!prenotaAttivo" xs12 md3>
              <v-text-field v-model="telefono" class="pa-3" type="tel" placeholder="Numero telefono"></v-text-field>
            </v-flex>

            <v-flex v-show="!prenotaAttivo" xs12 md3>
              <v-text-field v-model="email" class="pa-3" type="email" placeholder="E-mail"></v-text-field>
            </v-flex>

            <v-flex xs12 md4>

            </v-flex>

            <v-flex xs12 md4>
              <v-btn v-show="prenotaMattino || prenotaPomeriggio" large 
                    @click="checkOut(servizio.nome, servizio.prezzo, servizio.acconto, servizio.durata, servizio.effetto)"
                    class="lash white--text mt-4 mb-2 lash-btn-prnt"                 
                    :disabled="nomeCliente == '' || cognomeCliente == '' || telefono == null || telefono == ''">
                    PRENOTA
              </v-btn>
  
            </v-flex>
              
            <v-flex xs12 md4>
              
            </v-flex> 

          </v-layout>
   
        </v-container>     
        
      </v-expansion-panel-content>
      <v-snackbar v-model="snackbar" :timeout="10000" color="success">
        <span>Prenotazione in esame. Riceverai conferma prenotazione approvata.</span>
        <v-btn flat color="white" @click="snackbar=false">Close</v-btn>
      </v-snackbar>
    </v-expansion-panel>

  </v-container>
  <!-- <v-container v-else>
    <h2 :class="{'display-1': $vuetify.breakpoint.lgAndDown, 
                 'headline': $vuetify.breakpoint.smAndDown,
                 'title': $vuetify.breakpoint.xsAndDown}" 
                 class="mt-5 display-2 grey--text">
      Per utilizzare i nostri servizi, puoi effettuare l'accesso tramite Facebook e Google, o se preferisci registrati con email e password 
    </h2>
  </v-container> -->

 </div>
</template>

<script>
import format from "date-fns/format"
import addMinutes from "date-fns/add_minutes"
import addHours from "date-fns/add_hours"
import setMinutes from "date-fns/set_minutes"
import setHours from "date-fns/set_hours"
import subHours from "date-fns/sub_hours"
import subMinutes from "date-fns/sub_minutes"
import fb from "@/fb"

export default {

  data() {
    return {
      servizi: [],
      lashmaker: [],
      orarioLashmaker: [],
      select: "",
      nomeSelezionato: "",
      prenotaMattino: false,
      prenotaPomeriggio: false,
      prenotaAttivo: true,
      orarioPrenotazione: "00:00",
      orariDisponibili: [],      
      today: new Date().toISOString().substr(0, 10),
      picker: null,
      settimana: [],
      ferie: [],
      nomecognome: "",
      intervallo: null,
      menu1: false,
      limiteMattino: "",
      limitePomeriggio: "",
      snackbar: false,
      userVerified: false,
      userAdmin: false,
      email: "",
      nomeCliente: "",
      cognomeCliente: "",
      telefono: null,
      nomeServizio: "",
      prezzo: 0,
      durataServizio: "",
      effettoServizio: "",
      luxury: "",
      panel: -1,
      operatrice: "",
      dialog: false,
      layoutMattino: "",
      layoutPomeriggio: "",
      appuntamenti: []
    }
  },

  computed: {
    nomeTrattamento() {
      return this.servizi.map(servizio => {
        let lux = null
        let eff = null
        if (servizio.effetto == "Laminazione") {
          eff = " "
        } else {
          eff = " Effetto "
        }
        if (servizio.luxury) {
          lux = "LUXURY"
        } else {
          lux = "BASE"
        }
        return servizio.nome + eff + servizio.effetto + " " + servizio.nota + " versione " + lux
      })
    },
    idTrattamento() {
      return this.servizi.map(servizio => {
        return servizio.id
      })
    },
    nomeLashmaker() {   
      return this.lashmaker.map(lashmaker => {
        return lashmaker.nome + " " +lashmaker.cognome
      })
    },
    formattedDate() {
      return this.picker ? format(this.picker, "DD-MM-YYYY") : ""
    },
    minDate() {
      //var gg = this.today.substr(8,2)
      var gg = parseInt(this.today.substr(8,2), 10) + 1
      //var ggStringa = gg.toString()
      var ggStringa = (gg < 10) ? '0' + gg.toString() : gg.toString()
      var domani = this.today.substr(0,8) + ggStringa
      return domani
    },
    lrgData() {
      if (this.$vuetify.breakpoint.name == 'xs') {
        return true
      } else {
        return false
      }
    }    
  }, 
  methods: {

    trattamentoSelezionato(nomeServizio, prezzoServizio, durataServizio, effetto, luxury) {
      //Ogni volta svuoto tutte le tabelle e i campi
      this.layoutMattino = "",
      this.layoutPomeriggio = "",
      this.orariDisponibili = [],
      this.nomeCliente = "",
      this.cognomeCliente = "",
      this.telefono = null,
      this.picker = ""
      this.prenotaAttivo = true
      this.prenotaMattino = false
      this.prenotaPomeriggio = false
      this.lashmaker = []
      this.nomecognome = ""

      this.nomeServizio = nomeServizio
      this.prezzo = prezzoServizio
      this.durataServizio = durataServizio
      this.effettoServizio = effetto
      this.luxury = luxury
      fb.db.collection('lashmaker').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          // carico tabella lashmaker solo se sono abilitate al trattamento selezionato
          if ( change.type === "added" && 
               change.doc.data().effetti.some(even => {return even == effetto})   )  {
            this.lashmaker.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
        })
      })

      this.lashmaker.push({
        nome : "Indifferente",
        cognome : ""
      })

      // Leggo Giorni della Settimana con relativi valori flag
      fb.db.collection('chiusuraSettimanale').orderBy("indice").onSnapshot(res => {
          const changes = res.docChanges()
          changes.forEach(change => {
              if (change.type === "added")  {
              this.settimana.push({
                  ...change.doc.data(),
                  id: change.doc.id
              })
              }
          })
      })    

      // Leggo giorno inizio ferie e giorno fine ferie
      fb.db.collection('ferie').onSnapshot(res => {
          const changes = res.docChanges()
          changes.forEach(change => {
              if (change.type === "added")  {
              this.ferie.push({
                  ...change.doc.data(),
                  id: change.doc.id
              })
              }
          })
      })
    },

    allowedDates(dataInEsame) {
        try {
              if (dataInEsame >= this.ferie[0].dateIn && dataInEsame <= this.ferie[0].dateOut)  {
                  return false
              } else {
                  let val1 = format(dataInEsame,"ddd",{ locale: require('date-fns/locale/it') })
                  let val2 = val1.charAt(0).toUpperCase() + val1.slice(1)

                  // cerco il giorno in esame nell'orario della Lashmaker
                  let val =  this.orarioLashmaker.find(resLash => resLash.nomeGiorno == val2)
                  // se queste condizioni si verificano, allora significa che il giorno preso in 
                  // esame non è un giorno di lavoro della Lashmaker selezionata
                  if ((val.inizio1 == "00:00") && (val.inizio2 == "00:00")) {
                    return false
                  }
                  return this.preGiornoSelezionato(dataInEsame, val, val2)           
                  //return this.settimana.find(res => res.nomeGiorno == val2).aperto
              }  
        }
        // eslint-disable-next-line
        catch(error) {              
        }   
    },

    // Si attiva quando seleziono il giorno disponibile dal calendario
    prenota() {
      if (this.nomecognome == "" || this.nomecognome == null || this.nomecognome.split(" ")[0] == "Indifferente") {
        // Se non è stata selezionata alcuna Lashmaker o è stato selezionato "Indifferente" allora
        // dovrò caricare da collection la prima Lashmaher disponibile per quel trattamento
        
        // Provvisorio assegna la Lashmaker in maniera randomica
        
        if (this.lashmaker.length == 2) {
          this.nomecognome = this.lashmaker[1].nome + " " + this.lashmaker[1].cognome
        } else if (this.lashmaker.length >= 3) {
          let x = Math.random()
          if (x < 0.5) {
            this.nomecognome = this.lashmaker[1].nome + " " + this.lashmaker[1].cognome
          } else {
            this.nomecognome = this.lashmaker[2].nome + " " + this.lashmaker[2].cognome
          }
        }
      }
      this.calendarioLashmaker(this.nomecognome)
    },

    checkOut(nomeServizio, prezzo, acconto, durata, effetto) {
      /* A questo punto ho tutti i dati disponibili per creare un appuntamento  
          Appuntamento : 
                        data --> data
                        ora --> time (hh:mm)
                        nome Lashmaker --> nome
                        cognome Lashmaker --> cognome
                        effetti Lashmaker --> effettiLashmaker
                        nome servizio --> nomeServizio (param)
                        durata servizio --> durataServizio (param)
                        prezzo servizio --> prezzoServizio (param)
      */
      var nome = this.nomecognome.split(" ")[0]
      var cognome = this.nomecognome.split(" ")[1] 
      //SE IL CAMPO ACCONTO E' UGUALE A TRUE E L'UTENTE NON E' ADMIN ALLORA APRI LA TRANSAZIONE PAYPAL      
      if (acconto == true && this.userAdmin != true) {
        const appuntamento = {
            data : format(this.picker, "YYYY-MM-DD"),
            ora : this.orarioPrenotazione,
            nomeLashmaker : nome,
            cognomeLashmaker : cognome,
            nomeServizio : nomeServizio,
            effetto: effetto,
            durataServizio : durata,
            prezzoServizio : prezzo,
            luxury: this.luxury,
            email: this.email,
            nomeCliente: this.nomeCliente,
            cognomeCliente: this.cognomeCliente,
            telefono: this.telefono,
            stato : "da approvare",
            tipo : "appuntamento"
        }
        this.$router.push({ name: "pagamento", params: {appuntamento: appuntamento} })        
      // ALTRIMENTI SALVA DIRETTAMENTE L'APPUNTAMENTO SUL DATABASE
      } else {
        const appuntamento = {
          data : format(this.picker, "YYYY-MM-DD"),
          ora : this.orarioPrenotazione,
          nomeLashmaker : nome,
          cognomeLashmaker : cognome,
          nomeServizio : nomeServizio,
          effetto: effetto,
          durataServizio : durata,
          luxury: this.luxury,
          email: this.email,
          nomeCliente: this.nomeCliente,
          cognomeCliente: this.cognomeCliente,
          telefono: this.telefono,
          stato : "da approvare",
          tipo : "appuntamento"
        }
        fb.db.collection('appuntamenti').add(appuntamento).then(
          this.snackbar = true,
          this.panel = -1,
          this.orariDisponibili = []
        )         
      }

    },

    preGiornoSelezionato(dataInEsame, val, val2) {

      var disponibilita = false

      // Ottengo nome e cognome della lashmaker selezionata
      var nome = this.nomecognome.split(" ")[0]
      var cognome = this.nomecognome.split(" ")[1]
      var dataQuery = format(dataInEsame, "YYYY-MM-DD")

      var appuntamentiLashmaker = []
      appuntamentiLashmaker = this.appuntamenti.filter(elem => elem.nomeLashmaker == nome &&
                                           elem.cognomeLashmaker == cognome &&
                                           elem.data == dataQuery)
            
      // Se l'array è vuoto allora significa che quel giorno è completamente 
      // disponibile per eventuali appuntamenti quindi ritorno true
      if ( appuntamentiLashmaker.length == 0 ) {
        disponibilita = true
      }


      // Estraggo ora e minuto di inizio lavoro della lashmaker per il giorno in esame
      let oraInizio1 = val.inizio1.substr(0,2)
      let minutoInizio1 = val.inizio1.substr(3,2)

      // Li imposto nella data selezionata dall'utente
      let dataTot1 = setHours(dataInEsame, oraInizio1)
      dataTot1 = setMinutes(dataTot1, minutoInizio1)

      // Aggiungo la durata del servizio richiesto + intervallo
      dataTot1 = addHours(dataTot1, this.durataServizio.substr(0,2))
      dataTot1 = addMinutes(dataTot1, this.durataServizio.substr(3,2))
      dataTot1 = addHours(dataTot1, this.intervallo.substr(0,2))
      dataTot1 = addMinutes(dataTot1, this.intervallo.substr(3,2))

      // Creo una variabile che contenga solamente hh:mm
      let timeTot1 = dataTot1.toLocaleTimeString(navigator.language, {
              hour: '2-digit',
              minute:'2-digit'
      })

      // Estraggo ora e minuto di inizio lavoro della lashmaker per il giorno in esame
      let oraInizio2 = val.inizio2.substr(0,2)
      let minutoInizio2 = val.inizio2.substr(3,2)

      // Li imposto nella data selezionata dall'utente
      let dataTot2 = setHours(dataInEsame, oraInizio2)
      dataTot2 = setMinutes(dataTot2, minutoInizio2)

      // Aggiungo la durata del servizio richiesto + intervallo
      dataTot2 = addHours(dataTot2, this.durataServizio.substr(0,2))
      dataTot2 = addMinutes(dataTot2, this.durataServizio.substr(3,2))
      dataTot2 = addHours(dataTot2, this.intervallo.substr(0,2))
      dataTot2 = addMinutes(dataTot2, this.intervallo.substr(3,2))

      // Creo una variabile che contenga solamente hh:mm
      let timeTot2 = dataTot2.toLocaleTimeString(navigator.language, {
              hour: '2-digit',
              minute:'2-digit'
      })

      appuntamentiLashmaker.forEach( elem => {
        // Se l'orario fine mattino della lashmaker è diverso da zero, allora sappiamo 
        // che quella lashmaker lavorerà quel mattino, inoltre se l'orario
        // dell'appuntamento è minore dell'orario fine mattino della lashmaker
        // allora siamo sicuri si tratti di un appuntamento preso di mattina
        
        if ( (val.inizio1 != "00:00") && ( elem.ora < val.fine1 ) && ( disponibilita != true) ) {

          // se ora inzio lavoro + trattamento selezionato + intervallo é minore o uguale
          // a orario appuntamento allora mattino disponibile per un ulteriore appuntamento
          // quindi ritorno true

          if ( ( timeTot1 <= elem.ora &&
                 timeTot1 <= val.fine1 )  ) {     
              disponibilita = true
          } else {
          // altrimenti
              dataTot1 = setHours(dataTot1, elem.ora.substr(0,2))
              dataTot1 = setMinutes(dataTot1, elem.ora.substr(3,2))
              dataTot1 = addHours(dataTot1, elem.durataServizio.substr(0,2))
              dataTot1 = addMinutes(dataTot1, elem.durataServizio.substr(3,2))
              dataTot1 = addHours(dataTot1, this.intervallo.substr(0,2))
              dataTot1 = addMinutes(dataTot1, this.intervallo.substr(3,2))

              dataTot1 = addHours(dataTot1, this.durataServizio.substr(0,2))
              dataTot1 = addMinutes(dataTot1, this.durataServizio.substr(3,2))
              dataTot1 = addHours(dataTot1, this.intervallo.substr(0,2))
              dataTot1 = addMinutes(dataTot1, this.intervallo.substr(3,2))
          // Aggiorno timeTot1    
              timeTot1 = dataTot1.toLocaleTimeString(navigator.language, {
                  hour: '2-digit',
                  minute:'2-digit'
              })
           
          } 

        }

        // Se l'orario fine pomeriggio della lashmaker è diverso da zero, allora sappiamo 
        // che quella lashmaker lavorerà quel mattino, inoltre se l'orario
        // dell'appuntamento è maggiore dell'orario inizio pomeriggio della lashmaker
        // allora siamo sicuri si tratti di un appuntamento preso di pomeriggio
           
        if ( (val.inizio2 != "00:00") && ( elem.ora >= val.inizio2 ) && ( disponibilita != true) ) {
 
          // se ora inzio lavoro + trattamento selezionato + intervallo é minore o uguale
          // a orario appuntamento allora pomeriggio disponibile per un ulteriore appuntamento
          // quindi ritorno true
 
          if ( ( timeTot2 <= elem.ora &&
                 timeTot2 <= val.fine2 )  ) {
              disponibilita = true
          } else {
          // altrimenti 
              dataTot2 = setHours(dataTot2, elem.ora.substr(0,2))
              dataTot2 = setMinutes(dataTot2, elem.ora.substr(3,2))
              dataTot2 = addHours(dataTot2, elem.durataServizio.substr(0,2))
              dataTot2 = addMinutes(dataTot2, elem.durataServizio.substr(3,2))
              dataTot2 = addHours(dataTot2, this.intervallo.substr(0,2))
              dataTot2 = addMinutes(dataTot2, this.intervallo.substr(3,2))

              dataTot2 = addHours(dataTot2, this.durataServizio.substr(0,2))
              dataTot2 = addMinutes(dataTot2, this.durataServizio.substr(3,2))
              dataTot2 = addHours(dataTot2, this.intervallo.substr(0,2))
              dataTot2 = addMinutes(dataTot2, this.intervallo.substr(3,2))
              
              // Aggiorno timeTot2    
              timeTot2 = dataTot2.toLocaleTimeString(navigator.language, {
                      hour: '2-digit',
                      minute:'2-digit'
              })
                                                
          } 

        }           

      })

      if ( disponibilita == false ) {
          
          if ( ( timeTot1 <= val.fine1 ) || ( timeTot2 <= val.fine2 ) ) {
            //if ((val2 == "Mer") && (dataInEsame == "2019-11-13")) {
            //  console.log("1 - ", timeTot1, val.fine1, "2 - ", timeTot2, val.fine2)
            //}            
            return true   
          } else {
            return false
          }
      } else {
        return this.settimana.find(res => res.nomeGiorno == val2).aperto
      }           
 
    },

    giornoSelezionato() {
      this.layoutMattino = ""
      this.layoutPomeriggio = ""
      this.orariDisponibili = []
      // Ottengo il nome della data selezionata ("Lun", "Mar", ecc)    
      let val1 = format(this.picker,"ddd",{ locale: require('date-fns/locale/it') })
      let val2 = val1.charAt(0).toUpperCase() + val1.slice(1)
      // Tramite la funzione js find, cerco il nome del giorno selezionato nell'array orarioLashmaker  
      const val = this.orarioLashmaker.find(res => res.nomeGiorno == val2)
      // Ottengo nome e cognome della lashmaker selezionata
      var nome = this.nomecognome.split(" ")[0]
      var cognome = this.nomecognome.split(" ")[1]
      // EffettiLashmaker è un Array
      //var effettiLashmaker = this.lashmaker.find(res => res.nome == nome && res.cognome == cognome).effetti

      // A questo punto del programma i giorni non lavorativi della lashmaker sono già 
      // stati filtrati quindi :
      // Se il mattino non è vuoto, mostra gli orari della lashmaker disponibili al mattino
      if (val.inizio1 != "00:00") {
        this.limiteMattino = val.fine1
        // Estraggo ora e minuto di inizio lavoro
        let oraInizio = val.inizio1.substr(0,2)
        let minutoInizio = val.inizio1.substr(3,2)
        // Li imposto nella data selezionata dall'utente
        let data = setHours(this.picker, oraInizio)
        data = setMinutes(data, minutoInizio)
        // Creo una variabile che contenga solamente hh:mm
        let time = data.toLocaleTimeString(navigator.language, {
          hour: '2-digit',
          minute:'2-digit'
        })
        // Espongo tutti gli orari della data e della Lashmaker in oggetto estrendoli
        // dalla collection appuntamenti
        var dataQueryMattino = format(data, "YYYY-MM-DD") 
        fb.db.collection('appuntamenti')
          .where('cognomeLashmaker','==', cognome)
          .where('nomeLashmaker','==', nome)
          .where('data','==', dataQueryMattino)
          .orderBy("ora")
          .onSnapshot(res => {

          // Estraggo ora e minuto di fine lavoro
          let oraFine = val.fine1.substr(0,2)
          let minutoFine = val.fine1.substr(3,2)
          // Li imposto nella data selezionata dall'utente
          let dataFine = setHours(this.picker, oraFine)
          dataFine = setMinutes(dataFine, minutoFine)
          // Estraggo ora e minuto della durata del servizio
          let oraDurata = this.durataServizio.substr(0,2)
          let minutoDurata = this.durataServizio.substr(3,2)
          // e li sottraggo alla data fine assegnando il tutto ad una var fine
          let fine = subHours(dataFine, oraDurata)
          fine = subMinutes(fine, minutoDurata)
          // Creo una variabile che contenga solamente hh:mm
          let timeFine = fine.toLocaleTimeString(navigator.language, {
            hour: '2-digit',
            minute:'2-digit'
          })      
          // Creo un array temporaneo al cui interno salverò tutti gli orari prenotati
          // per il giorno e lashmakeker in questione con relativa durata del trattamento
          let prenotazioniMattino = []
          res.forEach(elem => {
            let oggettoPrenotazioni = {
              ora : "",
              durata : ""
            }
            oggettoPrenotazioni.ora = elem.data().ora
            oggettoPrenotazioni.durata = elem.data().durataServizio
            // Analizzando il mattino ovviamente dovrò caricare sull'array solo gli 
            // appuntamenti riguardanti il mattino
            if (oggettoPrenotazioni.ora < val.fine1) {
                prenotazioniMattino.push(oggettoPrenotazioni)
            }                      
          })
          // Quindi Inizio il ciclo che analizza tutti gli orari da val.inizio1 a val.fine1
          // Nota: Non si può gestire la cosa numericamente in quanto occorre utlizzare le 
          // funzioni date/fns che gestiscono indipendentemente l'aggiunta di minuti      
          while (time <= timeFine) {       
            // Estraggo ore e minuti della durata del servizio prenotato
            let oraDurataServizio = this.durataServizio.substr(0,2)
            let minutoDurataServizio = this.durataServizio.substr(3,2)
            // Estraggo ore e minuti dell'orario preso in esame all'interno del loop
            let oraTime = time.substr(0,2)
            let minutoTime = time.substr(3,2)
            // Li imposto nella data selezionata dall'utente
            let dataTime = setHours(this.picker, oraTime)
            dataTime = setMinutes(dataTime, minutoTime)
            // Aggiungo alla data comprensiva di orario, la durata del trattamento
            dataTime = addHours(dataTime, oraDurataServizio)
            dataTime = addMinutes(dataTime, minutoDurataServizio)
            // Creo una variabile che contenga solamente hh:mm
            let totalTime = dataTime.toLocaleTimeString(navigator.language, {
              hour: '2-digit',
              minute:'2-digit'
            })
            // A questo punto in totalTime ci sarà l'orario preso in esame 
            // + la durata del servizio
            // quindi utilizzo una variabile booleana che setterò a false se almeno
            // un orario prenotato sarà minore di totalTime     
            var test = true
            prenotazioniMattino.forEach(prnt => {
              let tot = new Date()
              tot = setHours(tot , prnt.ora.substr(0,2))
              tot = setMinutes(tot , prnt.ora.substr(3,2))
              tot = addHours(tot, prnt.durata.substr(0,2))
              tot = addMinutes(tot, prnt.durata.substr(3,2))
              // Creo una variabile che contenga solamente hh:mm
              let totTime = tot.toLocaleTimeString(navigator.language, {
                hour: '2-digit',
                minute:'2-digit'
              })
              if ((prnt.ora <= time && totTime >= time) || 
                  (prnt.ora <= totalTime && totTime >= totalTime) ||
                  (time <= prnt.ora && totalTime >= totTime)) {
                test = false
              }
            })        
            // Se test è uguale a true allora l'orario in esame 
            // sarà disponibile per la prenotazione
            if (test == true) {
              const timeSelected = {
              time : time,
              selected : false
              }
              this.layoutMattino = "Mattino"
              this.orariDisponibili.push(timeSelected)
            } 
            data = addMinutes(data,this.intervallo.substr(3,2))
            time = data.toLocaleTimeString(navigator.language, {
              hour: '2-digit',
              minute:'2-digit'
            })                       
          }           
        })
        this.prenotaMattino = true
      } else {
        this.layoutMattino = "Mattino Chiuso"
      }
      
       // Se il pomeriggio non è vuoto, mostra gli orari della lashmaker disponibili al pomeriggio
      if (val.inizio2 != "00:00") {
        this.limitePomeriggio = val.inizio2
        // Estraggo ora e minuto di inizio lavoro
        let oraInizio = val.inizio2.substr(0,2)
        let minutoInizio = val.inizio2.substr(3,2)
        // Li imposto nella data selezionata dall'utente
        let data = setHours(this.picker, oraInizio)
        data = setMinutes(data, minutoInizio)
        // Creo una variabile che contenga solamente hh:mm
        let time = data.toLocaleTimeString(navigator.language, {
          hour: '2-digit',
          minute:'2-digit'
        })
        // Espongo tutti gli orari della data e della Lashmaker in oggetto estrendoli
        // dalla collection appuntamenti
        var dataQueryPomeriggio = format(data, "YYYY-MM-DD")
        fb.db.collection('appuntamenti')
          .where('cognomeLashmaker','==', cognome)
          .where('nomeLashmaker','==', nome)
          .where('data','==', dataQueryPomeriggio)
          .orderBy("ora")
          .onSnapshot(res => {
          // Estraggo ora e minuto di fine lavoro
          let oraFine = val.fine2.substr(0,2)
          let minutoFine = val.fine2.substr(3,2)
          // Li imposto nella data selezionata dall'utente
          let dataFine = setHours(this.picker, oraFine)
          dataFine = setMinutes(dataFine, minutoFine)
          // Estraggo ora e minuto della durata del servizio
          let oraDurata = this.durataServizio.substr(0,2)
          let minutoDurata = this.durataServizio.substr(3,2)
          // e li sottraggo alla data fine assegnando il tutto ad una var fine
          let fine = subHours(dataFine, oraDurata)
          fine = subMinutes(fine, minutoDurata)
          // Creo una variabile che contenga solamente hh:mm
          let timeFine = fine.toLocaleTimeString(navigator.language, {
            hour: '2-digit',
            minute:'2-digit'
          })    
          // Creo un array temporaneo al cui interno salverò tutti gli orari prenotati
          // per il giorno e lashmakeker in questione con relativa durata del trattamento
          let prenotazioniPomeriggio = []
          res.forEach(elem => {
            let oggettoPrenotazioni = {
              ora : "",
              durata : ""
            }
            oggettoPrenotazioni.ora = elem.data().ora
            oggettoPrenotazioni.durata = elem.data().durataServizio
            // Analizzando il pomeriggio ovviamente dovrò caricare sull'array solo gli 
            // appuntamenti riguardanti il pomeriggio
            if ((oggettoPrenotazioni.ora >= val.inizio2 ) ||
                (elem.data().tipo == "evento")) {
                prenotazioniPomeriggio.push(oggettoPrenotazioni)
            }               
          })
          // Quindi Inizio il ciclo che analizza tutti gli orari da val.inizio2 a val.fine2
          // Nota: Non si può gestire la cosa numericamente in quanto occorre utlizzare le 
          // funzioni date/fns che gestiscono indipendentemente l'aggiunta di minuti 
          while (time <= timeFine) {       
            // Estraggo ore e minuti della durata del servizio prenotato
            let oraDurataServizio = this.durataServizio.substr(0,2)
            let minutoDurataServizio = this.durataServizio.substr(3,2)
            // Estraggo ore e minuti dell'orario preso in esame all'interno del loop
            let oraTime = time.substr(0,2)
            let minutoTime = time.substr(3,2)
            // Li imposto nella data selezionata dall'utente
            let dataTime = setHours(this.picker, oraTime)
            dataTime = setMinutes(dataTime, minutoTime)
            // Aggiungo alla data comprensiva di orario, la durata del trattamento
            dataTime = addHours(dataTime, oraDurataServizio)
            dataTime = addMinutes(dataTime, minutoDurataServizio)
            // Creo una variabile che contenga solamente hh:mm
            let totalTime = dataTime.toLocaleTimeString(navigator.language, {
              hour: '2-digit',
              minute:'2-digit'
            })
            // A questo punto in totalTime ci sarà l'orario preso in esame 
            // + la durata del servizio
            // quindi utilizzo una variabile booleana che setterò a false se almeno
            // un orario prenotato sarà minore di totalTime     
            var test = true
            prenotazioniPomeriggio.forEach(prnt => {
              let tot = new Date()
              tot = setHours(tot , prnt.ora.substr(0,2))
              tot = setMinutes(tot , prnt.ora.substr(3,2))
              tot = addHours(tot, prnt.durata.substr(0,2))
              tot = addMinutes(tot, prnt.durata.substr(3,2))
              // Creo una variabile che contenga solamente hh:mm
              let totTime = tot.toLocaleTimeString(navigator.language, {
                hour: '2-digit',
                minute:'2-digit'
              })
              // prnt.ora (Orario prenotazione già effettuata)
              // time (Orario inizio servizio dell'ipotetica prenotazione)
              // totTime (Orario finale del servizio della prenotazione già fatta)
              // totalTime (Orario finale del servizio dell'ipotetica prenotazione)
              if ((prnt.ora <= time && totTime >= time) || 
                  (prnt.ora <= totalTime && totTime >= totalTime) ||
                  (time <= prnt.ora && totalTime >= totTime)) {
                test = false
              }
              //console.log(prnt.ora, time, totTime, totalTime ,test)
            })        
            // Se test è uguale a true allora l'orario in esame 
            // sarà disponibile per la prenotazione
            if (test == true) {
              const timeSelected = {
              time : time,
              selected : false
              }
              this.layoutPomeriggio = "Pomeriggio"
              this.orariDisponibili.push(timeSelected)
            } 
            data = addMinutes(data,this.intervallo.substr(3,2))
            time = data.toLocaleTimeString(navigator.language, {
              hour: '2-digit',
              minute:'2-digit'
            })                       
          }           
        })
        this.prenotaPomeriggio = true
      } else {
        this.layoutPomeriggio = "Pomeriggio Chiuso"
      }
      // Se i campi di layoutMattino/Pomeriggio sono vuoti allora non ci sono Lashmaker disponibili
      if (this.layoutMattino == "") {
        this.layoutMattino = "Lashmaker non disponibile questa mattina"
      }
      if (this.layoutPomeriggio == "") {
        this.layoutPomeriggio = "Lashmaker non disponibile questo pomeriggio"
      }      
    },
    
    // Richiamato quando la cliente seleziona un orario fra quelli disponibili
    orarioSelezionato(orario, index) {
      this.orarioPrenotazione = orario
      // Imposto tutti i bottoni a off
      this.orariDisponibili.forEach(res => {
        res.selected = false
      })
      // Attivo l'unico bottone selezionato
      this.orariDisponibili[index].selected = !this.orariDisponibili[index].selected
      this.prenotaAttivo = false

    },
    
    // Si attiva quando seleziono una Lashmaker
    calendarioLashmaker(nomecognome) {
        this.prenotaMattino = false
        this.prenotaPomeriggio = false
        this.prenotaAttivo = true
        this.orariDisponibili = []
        if (nomecognome != "" && nomecognome != null) {       
          // Divido nomecognome in 2 costanti rispettivamente nome e cognome
          const nome = nomecognome.split(" ")[0]
          const cognome = nomecognome.split(" ")[1]
          this.orarioLashmaker= []
          // Gestioni fascia oraria per singolo giorno
          fb.db.collection('orarioLashmaker').where('cognome','==', cognome).where('nome','==', nome)
                .orderBy("indice")
                .onSnapshot(res => {
              const changes = res.docChanges()
              changes.forEach(change => { 
                      if (change.type === "added")  {
                      this.orarioLashmaker.push({
                          ...change.doc.data(),
                          id: change.doc.id
                      })
                  }
              })
          })
        }            
    }
  },

  beforeCreate() {
    fb.db.collection('servizi').orderBy('indice').onSnapshot(res => {
      const changes = res.docChanges()
      changes.forEach(change => {
        if (change.type === "added")  {
          this.servizi.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    }),

    fb.db.collection('intervalli').doc('intervallo').get().then(res => {
      this.intervallo = res.data().intervallo
    })

    fb.auth.onAuthStateChanged(user => {
      //console.log(user.providerData[0].providerId )
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          this.email = idTokenResult.claims.email
          var emailVerified = user.emailVerified
          if (idTokenResult.claims.admin) {
             this.userAdmin = true
          }
          if (idTokenResult.claims.admin == true || emailVerified == true || 
              user.providerData[0].providerId == "facebook.com" || 
              user.providerData[0].providerId == "google.com" ) {
             this.userVerified = true
          } else {
             this.userVerified = false
          } 
        })
      } else {
        this.userVerified = false
      }
    })

    var oggi = new Date()
    var dataQuery = format(oggi, "YYYY-MM-DD")
    fb.db.collection('appuntamenti')
      .where('data','>', dataQuery)
      .orderBy("data")
      .orderBy("ora")
      .onSnapshot(res => {
        const changes = res.docChanges()     
        changes.forEach( change => {
          if (change.type === "added")  {
            this.appuntamenti.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
        })
      }) 
  }
}
</script>

<style>
.lash-btn{color: white!important; background-color: #dc3545!important;}
.lash-route{text-decoration: none;}
.lash-btn-prnt{width: 95%;}
.lash-text{color: #dc3545}
.orari{border-left: 1px solid #E0E0E0!important}
.myStyle1{font-size: 20px!important;}
.myStyle2{font-size: 15px!important; line-height: 20px!important;}
.myStyle3{font-size: 13px!important; line-height: 20px!important;}
.myStyle4{font-size: 11px!important; line-height: 20px!important;}
.smallBtn{max-width: 10px!important;}
.v-expansion-panel__header__icon i.v-icon.material-icons.theme--light{display: none;}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.clearfix { display: inline-block; }
/* start commented backslash hack \*/
* html .clearfix { height: 1%; }
.clearfix { display: block; }
/* close */
@media (max-width: 600px) {
  a.v-list__tile.v-list__tile--link.theme--light{font-size: 13px; height: 30px!important;}
  a.v-list__tile.v-list__tile--link.v-list__tile--active.theme--light.primary--text .v-list__tile__title{font-size: 18px;}
  label{font-size: 13px!important;}

}
</style>
